export const cleanHtml = (htmlString) => {
	const s = '<div id="texto">' + htmlString + "</div>"
	const htmlObject = document.createElement("div")
	htmlObject.innerHTML = s

	return htmlObject.getElementsByTagName("div").texto.textContent
}
